import { render, staticRenderFns } from "./OverviewBestTimes.vue?vue&type=template&id=05d9b7b3&scoped=true&"
import script from "./OverviewBestTimes.vue?vue&type=script&lang=js&"
export * from "./OverviewBestTimes.vue?vue&type=script&lang=js&"
import style0 from "./OverviewBestTimes.vue?vue&type=style&index=0&id=05d9b7b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d9b7b3",
  null
  
)

export default component.exports